import styled from 'styled-components'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    width: 100%;
    height: calc(var(--full-height, 100dvh) - var(--header-height));

    &::before {
      position: absolute;
      z-index: -1;
      inset: 0;
      content: '';
      background-color: ${COLORS.GRAY_100};
    }
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    padding-bottom: calc(var(--sab, 0px) + 24px);
    height: 100%;
    overflow-y: auto;
  `,

  StyledForm: styled.form`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    color: ${COLORS.BLACK};
    margin-bottom: 16px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh28};
    }
  `,

  Subtitle: styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    margin-bottom: 24px;

    ${anatomyCompact} {
      margin-bottom: ${ANATOMY_COMPACT.spacing.s24};
    }
  `,

  InputWrapper: styled.div`
    width: 100%;
    position: relative;
  `,

  PrivacyRow: styled.div`
    display: flex;
    align-items: flex-start;
    gap: 4px;
    margin-bottom: 12px;
  `,

  LockIcon: styled.span`
    flex-shrink: 0;
    display: flex;
    align-items: center;
  `,

  PrivacyText: styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #6c7072;
  `,

  CheckboxRow: styled.div`
    display: flex;
    align-items: flex-start;
    gap: 4px;
    margin-bottom: 24px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  `,

  CheckboxContainer: styled.div`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  `,

  Checkbox: styled.div<{ $checked: boolean }>`
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 3px;
    border: ${({ $checked }) =>
      $checked ? 'none' : `2px solid ${COLORS.PURPLE_400}`};
    background: ${({ $checked }) =>
      $checked ? COLORS.PURPLE_400 : 'transparent'};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  `,

  CheckboxLabel: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: ${COLORS.GRAY_700};
  `,

  BonusCard: styled.div`
    display: flex;
    align-items: center;
    gap: 18px;
    background-color: #ddf0e2;
    border-radius: 15px;
    padding: 5px 15px;
    margin-bottom: 24px;
  `,

  BonusEmoji: styled.span`
    font-size: 28px;
    line-height: 1;
    flex-shrink: 0;
    padding: 8px;
    background: #d1e3d5;
    border-radius: 10px;
  `,

  BonusContent: styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
  `,

  BonusTitle: styled.p`
    font-size: 16px;
    line-height: 1;
    font-weight: 700;
    color: ${COLORS.BLACK};
  `,

  BonusSubtitle: styled.p`
    font-size: 14px;
    line-height: 1;
    color: #6e7375;
  `,

  StyledButton: styled(Button)`
    width: 100%;
    margin-top: auto;
  `,
} as const
